module.exports = __webpack_public_path__ + "create_project.88d625c8.mp4";